declare global {
  interface Window {
    translations: { [key: string]: string }
  }
}

export const translate = (key: string) => {
  return Reflect.get(window.translations ?? {}, key) ?? key
}
